
import React from 'react';
import { FaCheck, FaCamera, FaStar, FaQuoteLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import  Chatbot  from '../../../components/ui/chatbot';


const Home = () => {
    const services = [
        {
            id: 1,
            name: "Wedding Photography",
            description: "Capture your special day with comprehensive wedding coverage including ceremony, reception, and couple portraits.",
            price: 2500,
            duration: "8-10 hours",
            popular: true,
            image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=800&h=600&fit=crop",
            features: ["Full day coverage", "2 photographers", "500+ edited photos"]
        },
        {
            id: 2,
            name: "Portrait Session",
            description: "Professional portrait photography for individuals, families, or couples in studio or outdoor locations.",
            price: 350,
            duration: "1-2 hours",
            popular: false,
            image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=800&h=600&fit=crop",
            features: ["1-2 hour session", "Multiple outfit changes", "50+ edited photos"]
        }
    ];

    const testimonials = [
        {
            id: 1,
            name: "Sarah & James",
            text: "The wedding photos were absolutely stunning! They captured every special moment perfectly.",
            rating: 5
        },
        {
            id: 2,
            name: "Michael T.",
            text: "Professional, creative, and delivered beyond our expectations. Will definitely book again!",
            rating: 5
        }
    ];
    const navigate = useNavigate();

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };


    return (
        <div className="font-sans">
            {/* Hero Section */}
            <section className="relative h-[70vh] flex items-center justify-center text-white overflow-hidden ">
                {/* Background slider with smooth crossfade */}
                <div className="absolute inset-0">
                    {/* Image 1 */}
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-0"
                        style={{
                            backgroundImage: "url('https://cdn.prod.website-files.com/667c2b4d116853eb6040023d/68898df6ea8576d7fe90c8cd_668c2474cfdde8ea35dff75a__e3a4621%20copy_resized.avif')",
                            animation: "fadeInOut 15s infinite"
                        }}
                    />

                    {/* Image 2 */}
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-0"
                        style={{
                            backgroundImage: "url('https://cdn.prod.website-files.com/667c2b4d116853eb6040023d/6889934df92559fe8e4e9777_668e4498f55408a8b7dfae09_dsc03990%20copy_resized.avif')",
                            animation: "fadeInOut 15s infinite 5s"
                        }}
                    />

                    {/* Image 3 */}
                    <div
                        className="absolute inset-0 bg-cover bg-center opacity-0"
                        style={{
                            backgroundImage: "url('https://cdn.prod.website-files.com/667c2b4d116853eb6040023d/6889934d907a1a3f0a9d74fd_66c494ab96790348b31e5241_jules_andy_ocean20240729_0005_resized.avif')",
                            animation: "fadeInOut 15s infinite 10s"
                        }}
                    />

                    {/* Dark overlay */}
                    <div className="absolute inset-0 bg-black/50" />
                </div>

                {/* Foreground content */}
                <div className="relative z-10 text-center px-4 w-full flex flex-col items-center mt-20 mb-4">
                    <h1 className="text-4xl md:text-6xl font-bold mb-4 md:mb-6 text-center">
                        Studio Musu Photography
                    </h1>
                    <p className="text-xl md:text-2xl mb-8 md:mb-10 max-w-2xl mx-auto text-center">
                        Capturing your most precious moments with artistry and passion
                    </p>

                    <div className="flex flex-col sm:flex-row justify-center items-center gap-4 w-full max-w-md sm:max-w-none">
                        <button
                            onClick={() => scrollToSection('our-work')}
                            className="bg-white text-gray-900 px-6 sm:px-8 py-3 rounded-full font-semibold hover:bg-gray-200 transition w-full sm:w-auto"
                        >
                            View Our Work
                        </button>
                        <button

                            onClick={() => navigate('/service-booking')}

                            className="bg-white text-gray-900 px-6 sm:px-8 py-3 rounded-full font-semibold hover:bg-gray-200 transition w-full sm:w-auto">
                            Book a Session
                        </button>
                    </div>
                </div>

                {/* Animation styles */}
                <style>
                    {`
          @keyframes fadeInOut {
            0% {
              opacity: 0;
            }
            10% {
              opacity: 1;
            }
            33.333% {
              opacity: 1;
            }
            43.333% {
              opacity: 0;
            }
            100% {
              opacity: 0;
            }
          }
        `}
                </style>
            </section>

            {/* About Section */}
            <section className="py-20 px-4 max-w-6xl mx-auto">
                <div className="flex flex-col md:flex-row items-center gap-12">
                    <div className="md:w-1/2">
                        <h2 className="text-3xl font-bold mb-6">Our Story</h2>
                        <p className="text-gray-600 mb-4">
                            Founded in 2010, Studio Musu has been dedicated to creating timeless photographs that tell your unique story.
                        </p>
                        <p className="text-gray-600 mb-6">
                            Our team of passionate photographers combines technical expertise with artistic vision to deliver images you'll cherish forever.
                        </p>
                        <button
                            onClick={() => navigate('/about')}
                            className="border-2 border-gray-900 text-gray-900 px-6 py-2 rounded-full font-semibold hover:bg-gray-900 hover:text-white transition">
                            Meet The Team
                        </button>
                    </div>
<div className="md:w-1/2 grid grid-cols-2 gap-4">
  <img
    src="https://images.unsplash.com/photo-1554080353-a576cf803bda?w=500&h=500&fit=crop"
    alt="Photographer at work"
    className="rounded-lg shadow-md transform transition duration-500 hover:scale-105 hover:shadow-xl"
  />
  <img
    src="https://images.unsplash.com/photo-1509319117193-57bab727e09d?w=500&h=500&fit=crop"
    alt="Camera equipment"
    className="rounded-lg shadow-md mt-8 transform transition duration-500 hover:scale-105 hover:shadow-xl"
  />
</div>

                </div>
            </section>

            {/* Services Section */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-6xl mx-auto px-4">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl font-bold mb-4">Our Services</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            Professional photography services tailored to your needs
                        </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {services.map(service => (
                            <ServiceCard key={service.id} service={service} />
                        ))}
                    </div>

                    <div className="text-center mt-12">
                        <button
                            onClick={() => navigate('/service')}
                            className="bg-gray-900 text-white px-8 py-3 rounded-full font-semibold hover:bg-gray-700 transition">
                            View All Services
                        </button>
                    </div>
                </div>
            </section>

            {/* Portfolio Section */}
            <section className="py-20 px-4" id="our-work">
                <div className="max-w-6xl mx-auto">
                    <div className="text-center mb-16">
                        <h2 className="text-3xl font-bold mb-4">Our Portfolio</h2>
                        <p className="text-gray-600 max-w-2xl mx-auto">
                            A glimpse of our recent work
                        </p>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {/* Portfolio Item 1 - Wedding */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1583939003579-730e3918a45a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Wedding photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium">

                                    <a
                                        href="https://images.unsplash.com/photo-1583939003579-730e3918a45a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                        download="event-photo.jpg"
                                        className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                    > View Wedding</a>
                                </button>
                            </div>
                        </div>

                        {/* Portfolio Item 2 - Portrait */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Portrait photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium">
                                    <a
                                        href="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                        download="event-photo.jpg"
                                        className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                    >  View Portrait </a>
                                </button>
                            </div>
                        </div>

                        {/* Portfolio Item 3 - Event */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Event photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <a
                                    href="https://images.unsplash.com/photo-1492684223066-81342ee5ff30?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"

                                    className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                >
                                    View Portrait
                                </a>
                            </div>
                        </div>


                        {/* Portfolio Item 4 - Commercial */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Commercial photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium">
                                    <a href="https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                        download="event-photo.jpg"
                                        className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                    >   View Commercial</a>
                                </button>
                            </div>
                        </div>

                        {/* Portfolio Item 5 - Family */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1569074187119-c87815b476da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Family photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium">
                                    <a href="https://images.unsplash.com/photo-1569074187119-c87815b476da?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                        download="event-photo.jpg"
                                        className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                    >     View Family </a>
                                </button>
                            </div>
                        </div>

                        {/* Portfolio Item 6 - Product */}
                        <div className="relative group overflow-hidden rounded-lg shadow-md">
                            <img
                                src="https://images.unsplash.com/photo-1602143407151-7111542de6e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                alt="Product photography"
                                className="w-full h-64 object-cover transition-transform group-hover:scale-105"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-50 opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-center">
                                <button className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium">
                                    <a href="https://images.unsplash.com/photo-1602143407151-7111542de6e8?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&h=600"
                                        download="event-photo.jpg"
                                        className="bg-white text-gray-900 px-6 py-2 rounded-full font-medium"
                                    >    View Product</a>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials */}


            {/* CTA Section */}
            <section className="py-20 px-4 bg-blue-600 text-white">
                <div className="max-w-4xl mx-auto text-center">
                    <h2 className="text-3xl font-bold mb-6">Ready to Create Lasting Memories?</h2>
                    <p className="text-xl mb-8 max-w-2xl mx-auto">
                        Contact us today to book your session or discuss your photography needs
                    </p>
                    <div className="flex flex-col sm:flex-row justify-center gap-4">
                        <button
                            onClick={() => navigate('/service-booking')}
                            className="bg-white text-blue-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition">
                            Book a Session
                        </button>
                        <button
                            onClick={() => navigate('/contact')}
                            className="border-2 border-white text-white px-8 py-3 rounded-full font-semibold hover:bg-white hover:text-blue-600 transition">
                            Contact Us
                        </button>
                    </div>
                </div>
            </section>
            <Chatbot />
        </div>
    );
};

// Service Card Component
const ServiceCard = ({ service }) => {
    return (
        <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
            <div className="h-48 overflow-hidden group">
                <img
                    src={service.image}
                    alt={service.name}
                    className="w-full h-full object-cover transition-all duration-500 group-hover:scale-105 group-hover:brightness-110"
                />
            </div>
            <div className="p-6">
                <div className="flex justify-between items-start mb-3">
                    <h3 className="text-xl font-bold">{service.name}</h3>
                    {service.popular && (
                        <span className="bg-yellow-100 text-yellow-800 text-xs px-2 py-1 rounded-full">
                            Popular
                        </span>
                    )}
                </div>
                <div className="flex justify-between items-center mb-4">
                    <span className="text-gray-600">{service.duration}</span>
                    <span className="text-xl font-bold">${service.price}</span>
                </div>
                <p className="text-gray-700 mb-4">{service.description}</p>
                <ul className="space-y-2 mb-4">
                    {service.features.map((feature, index) => (
                        <li key={index} className="flex items-start">
                            <FaCheck className="text-green-500 mt-1 mr-2 flex-shrink-0" />
                            <span>{feature}</span>
                        </li>
                    ))}
                </ul>
                <a className='w-full bg-gray-900 text-white py-3 px-4 rounded-lg hover:bg-gray-700 transition block text-center'
                    href="/service">Learn More</a>
            </div>
        </div>
    );
};

// Testimonial Card Component


export default Home;